import { Twitter } from "lucide-react";

// Discord icon component (not available in lucide-react)
const DiscordIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-background relative overflow-hidden border-t border-border/50">
      {/* Grid pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,hsl(var(--muted-foreground)/0.08)_1px,transparent_1px)] bg-[size:40px_40px]" />

      {/* Links Section */}
      <div className="container mx-auto px-4 md:px-6 py-12 md:py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {/* Left Side - About DePIN Land */}
          <div className="max-w-md">
            <p className="text-xs font-semibold uppercase tracking-wider text-primary mb-4">DePIN Land</p>
            <p className="text-muted-foreground leading-relaxed mb-4">
            A web3 platform focused on educating, onboarding and enabling real world adoption of decentralized physical Infrastructure networks DePIN in Africa. 
            </p>
          </div>

          {/* Right Side - Links Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
            {/* Sitemap */}
            <div>
              <p className="text-xs font-semibold uppercase tracking-wider text-primary mb-4">Sitemap</p>
              <ul className="space-y-3">
                <li>
                  <a href="/" className="text-foreground hover:text-primary transition-colors">
                    Home
                  </a>
                </li>
                <li>
                  <a href="/ventures" className="text-foreground hover:text-primary transition-colors">
                    Ventures
                  </a>
                </li>
                <li>
                  <a href="/ecosystem" className="text-foreground hover:text-primary transition-colors">
                    Ecosystem
                  </a>
                </li>
                <li>
                  <a href="/blog" className="text-foreground hover:text-primary transition-colors">
                    Blog
                  </a>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div>
              <p className="text-xs font-semibold uppercase tracking-wider text-primary mb-4">Company</p>
              <ul className="space-y-3">
                <li>
                  <a href="/about" className="text-foreground hover:text-primary transition-colors">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="#" className="text-foreground hover:text-primary transition-colors">
                    Terms & Conditions
                  </a>
                </li>
                <li>
                  <a href="#" className="text-foreground hover:text-primary transition-colors">
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Large Brand Name */}
        <div className="relative mb-8">
          <div className="text-5xl sm:text-6xl md:text-8xl lg:text-[10rem] xl:text-[14rem] font-bold leading-none select-none text-center text-muted break-words">
            DePIN Land
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs uppercase tracking-wider">
          <p className="text-muted-foreground">©2026 DePIN Land. All rights reserved.</p>
          <div className="gap-6 flex-row flex items-center justify-center">
            <a
              href="https://x.com/Depinland_org"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-2 text-muted-foreground hover:text-primary transition-all duration-300"
              aria-label="X/Twitter"
            >
              <Twitter className="h-5 w-5 transition-transform duration-300 group-hover:scale-110 group-hover:-translate-y-1" />
              <span className="hidden sm:inline">X/Twitter</span>
            </a>
            <a
              href="https://discord.gg/paEy3nMcuH"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-2 text-muted-foreground hover:text-primary transition-all duration-300"
              aria-label="Discord"
            >
              <DiscordIcon className="h-5 w-5 transition-transform duration-300 group-hover:scale-110 group-hover:-translate-y-1" />
              <span className="hidden sm:inline">Discord</span>
            </a>
          </div>
          <p className="text-muted-foreground">A thing by the team</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
